import React from 'react';
import { Link } from 'react-router-dom';
import { Button, Container, Header, Input, Popup, Segment, Table } from 'semantic-ui-react';
import { toast } from 'react-semantic-toasts';
import request from '../../../../utils/request';
import tableStyles from '../../../../styles/table.module.scss';
import DeleteAction from '../../../../components/admin/DeleteAction';
import Pagination from '../../../../components/admin/Pagination';
import moment from 'moment';

const { Cell, HeaderCell, Row} = Table;
let timer = 0;

class AdminUsersListView extends React.Component
{
    state = {
        isLoading: false,
        query: '',
        pagination: {},
        users: [],
        confirmDelete: false,
    };

    /**
     * Mount
     */
    componentDidMount = () => {
        this.fetch();
    }

    /**
     * Delete user
     */
    deleteUser = (user) => {
        request.delete(`admin/users/${user.id}`).then(() => {
            this.fetch();

            toast({
                type: 'success',
                icon: '',
                description: 'User deleted succesfully',
                time: 2500,
            });
        });
    }

    /**
     * Send a password reset link
     */
    sendPassword = (user) => {
        request.post(`admin/users/${user.id}/send-password`).then(() => {
            toast({
                type: 'success',
                icon: '',
                description: 'Password reset link sent succesfully',
                time: 2500,
            });
        });
    }

    /**
     * Fetch
     */
    fetch = (page) => {
        request(`admin/users?q=${this.state.query}&page=${page || 1}`).then(({ data }) => {
            this.setState({
                isLoading: false,
                pagination: data.meta,
                users: data.data,
            });
        });
    }

    /**
     * Search
     */
    searchUsers = (query) => {
        clearTimeout(timer);

        this.setState({
            isLoading: true,
            query,
        });

        timer = setTimeout(() => { this.fetch(); }, 300);
    }

    // --- render
    render() {
        const { isLoading, pagination, query, users } = this.state;

        return (
            <Container className="admin-page">
                <Segment padded>
                    <div className="admin-page-header">
                        <Header as="h1">Users</Header>
                        <Link to="/admin/users/create">
                            <Button primary icon="plus" />
                        </Link>
                    </div>
                    <Input
                        fluid
                        loading={isLoading}
                        placeholder='Search...'
                        onChange={(e) => { this.searchUsers(e.target.value); }}
                        value={query}
                    />
                    <Table>
                        <Table.Header>
                            <Row>
                                <HeaderCell>Name</HeaderCell>
                                <HeaderCell singleLine>Email address</HeaderCell>
                                <HeaderCell>Role</HeaderCell>
                                <HeaderCell singleLine>Last login</HeaderCell>
                                <HeaderCell singleLine textAlign="right">Actions</HeaderCell>
                            </Row>
                        </Table.Header>
                        <Table.Body>
                            {users.map((user) => (
                                <Row key={user.id}>
                                    <Cell>
                                        <Link to={`/admin/users/${user.id}`}>
                                            {user.name}
                                        </Link>
                                    </Cell>
                                    <Cell>
                                        {user.email_address}
                                    </Cell>
                                    <Cell>
                                        {user.role === 'admin' ? 'Administrator' : 'User'}
                                    </Cell>
                                    <Cell>
                                        {user.last_login_at ? moment(user.last_login_at).format('DD MMMM YYYY - H:m') : '-'}
                                    </Cell>
                                    <Cell collapsing textAlign="right">
                                        <Link to={`/admin/users/${user.id}`}>
                                            <Button
                                                basic
                                                size="mini"
                                                icon="pencil"
                                            />
                                        </Link>
                                        <Popup
                                            content="Send a password reset link"
                                            inverted
                                            trigger={<Button
                                                basic
                                                size="mini"
                                                icon="paper plane"
                                                onClick={() => { this.sendPassword(user); }}
                                            />}
                                        />
                                        <span className={tableStyles.actionsDivider}> | </span>
                                        <DeleteAction
                                            message="Are you sure you want to delete this user?"
                                            onDelete={() => { this.deleteUser(user); }}
                                        />
                                    </Cell>
                                </Row>
                            ))}
                        </Table.Body>
                    </Table>
                </Segment>
                <Pagination data={pagination} onClick={this.fetch} />
            </Container>
        );
    }
}

export default AdminUsersListView;
